import { EFFICIENT_USER_ACTIONS } from '../../actions/efficientUserActions';

const efficientUserReducer = (state = {
  imageLoaded: 0,
  imagesToBeLoaded: 4,
  shcUserType : null
}, action) => {
  switch (action.type) {
    case EFFICIENT_USER_ACTIONS.FETCH_DATA:
      state = {
        ...state,
        shcUserType: action.payload.shcUserType
      }
      break;
    case EFFICIENT_USER_ACTIONS.IMAGE_LOADED:
      state = {
        ...state,
        imageLoaded: state.imageLoaded + 1
      }
      break;
    default:
      break;
  }
  return state;
};

export default efficientUserReducer;
